import Point = createjs.Point;

// in actionscript, positions on the max border are not counted for containsPoint
createjs.Rectangle.prototype.containsPoint = function (point: createjs.Point): boolean{
    return point.x >= this.x && point.x < this.x + this.width &&
        point.y >= this.y && point.y < this.y + this.height;
};
// contains should behave similar to containsPoint
createjs.Rectangle.prototype.contains = function(x: number, y: number): boolean {
    return x >= this.x && x < this.x + this.width &&
    y >= this.y && y < this.y + this.height;
};

createjs.Rectangle.prototype.offset = function (dx: number, dy: number): void {
    this.x += dx;
    this.y += dy;
};

createjs.Rectangle.prototype.offsetPoint = function (point: createjs.Point): void {
    this.offset(point.x, point.y);
};

createjs.Rectangle.prototype.inflate = function (dx: number, dy: number): void {
    this.x -= dx;
    this.width += 2 * dx;
    this.y -= dy;
    this.height += 2 * dy;
};

createjs.Rectangle.prototype.inflatePoint = function (point: createjs.Point): void {
    this.inflate(point.x, point.y);
};

Object.defineProperty(createjs.Rectangle.prototype, "top", {
    get: function (this: createjs.Rectangle) {
        return this.y;
    },
    set: function (this: createjs.Rectangle, value: number) {
        this.height+= this.y - value;
        this.y = value;
    },
    enumerable: true,
    configurable: true
});

Object.defineProperty(createjs.Rectangle.prototype, "bottom", {
    get: function (this: createjs.Rectangle) {
        return this.y + this.height;
    },
    set: function (this: createjs.Rectangle, value: number) {
        //this.height = value;
        this.height = value - this.y;
    },
    enumerable: true,
    configurable: true
});

Object.defineProperty(createjs.Rectangle.prototype, "left", {
    get: function (this: createjs.Rectangle) {
        return this.x;
    },
    set: function (this: createjs.Rectangle, value: number) {
        this.width+= this.x - value;
        this.x = value;
    },
    enumerable: true,
    configurable: true
});

Object.defineProperty(createjs.Rectangle.prototype, "right", {
    get: function (this: createjs.Rectangle) {
        return this.x + this.width;
    },
    set: function (this: createjs.Rectangle, value: number) {
        //this.width = value;
        this.width = value -this.x;
    },
    enumerable: true,
    configurable: true
});

Object.defineProperty(createjs.Rectangle.prototype, "topLeft", {
    get: function (this: createjs.Rectangle) {
        return new Point(this.x,this.y);
    },
    enumerable: true,
    configurable: true
});


Object.defineProperty(createjs.Rectangle.prototype, "size", {
    get: function (this: createjs.Rectangle) {
        return new Point(this.width,this.height);
    },
    enumerable: true,
    configurable: true
});


Object.defineProperty(createjs.Rectangle.prototype, "bottomRight", {
    get: function (this: createjs.Rectangle) {
        return new Point(this.x + this.width,this.y + this.height);
    },
    enumerable: true,
    configurable: true
});
